<label for="{{id}}" class="app-component-container"
  [ngClass]="{'size-sm': size.toLowerCase()=='sm', 'size-md': size.toLowerCase()=='md', 'size-lg': size.toLowerCase()=='lg'}">
  <div class="border-silver app-checkbox-containter border {{checked && !disabled ? bgColor : !checked && !disabled ? bgOffColor : 'bg-light'}}"
  [ngClass]="{'focus': focus && outline, 'checked': checked, 'unchecked': !checked, 'disabled text-muted': disabled}">
    <i class="circle border-silver border" [ngClass]="{'bg-light': disabled}"></i>
  </div>
  <div class="pl-3 this-label" *ngIf="label!=''">
      {{label}}
    </div>
  <input (change)="toggle()" [value]="checked" (focus)="focus=true" (blur)="focus=false" type="checkbox" id="{{id}}">
</label>
